import TabPage from "./../../factories/tab-page";
import "./../../factories/tab-controller";
import "./../../bindings/bao-tabs";
import * as ko from "knockout";
import Bao from "./../../services/bao-service";
import SubscriptionViewModel from "./../../factories/subscription-view-model";
import baoRouter from "./../../services/bao-router";
import BaoDialog from "./../../factories/bao-dialog";
import BaoMenu from "./../../services/bao-menu";
import finitoService from "./../../services/finito-service";
import TabController from "./../../factories/tab-controller";
class ShiftReportBypass extends SubscriptionViewModel {
    Bao = Bao;
    TabPage: TabPage;
    PageSize = ko.observable(10);
    TotalRows = ko.observable(0);
    PageIndex = ko.observable(0);
    Sorting = ko.observableArray();
    Columns = ko.observableArray([]);
    Fields = ko.observableArray([]);
    EnableCompleteDate = ko.observable(true);
    EvaluationCollection = ko.observableArray([]);
    SelectedEvaluationRow = ko.observable();
    ToolbarButtons = ko.observableArray();
    OriginalTabTitle: string = "";
    CustomFilter = ko.observable({});
    ShiftReport: {
        ReportId: KnockoutObservable<string>;
        ShiftbookId: KnockoutObservable<string>;
        ShiftStartTime: KnockoutObservable<string>;
        ShiftEndTime: KnockoutObservable<string>;
    } = null;
    constructor(tabPage: TabPage, parent: any) {
        super(tabPage);
        this.TabPage = tabPage;
        this.ShiftReport = parent;
        this.SelectedEvaluationRow.subscribe(() => {
            this.ToggleToolbarButtons();
        });
        this.CustomFilter.subscribe(() => {
            this.LoadData();
        });
        Bao.bindEvent('checklist-evaluation:refresh', () => this.LoadData());
    }
    init() {
        this.OriginalTabTitle = this.TabPage.Title();
        return this.LoadMetadata().then(() => this.LoadData());
    }
    loaded() {
        this.Sorting.subscribe(() => {
            this.LoadData();
        });
        this.PageIndex.subscribe(() => {
            this.LoadData();
        });
        this.PageSize.subscribe((newvalue) => {
            if (this.PageIndex() === 0) {
                this.LoadData();
            }
            else {
                this.PageIndex(0);
            }
        });
        this.TabPage.IsLoading(false);
    }
    dispose() {
        Bao.unbindEvent('checklist-evaluation:refresh', this.LoadData());
        super.dispose();
    }

    ToolbarLoaded = () => {
        this.ToggleToolbarButtons();
    };
    ToggleToolbarButtons = () => {
        ko.utils.arrayForEach(this.ToolbarButtons(), (button: any) => {
            if (button.ActionKey() == "ShiftReportTabBypassEdit") {
                button.Enabled(this.SelectedEvaluationRow() != null);
            }
            if (button.ActionKey() == "ShiftReportTabBypassDelete") {
                button.Enabled(this.SelectedEvaluationRow() != null);
            }
        });
    };
    toolbarClick = (action) => {
        switch (action.ActionKey()) {
            case "ShiftReportTabBypassNew":
                this.CreateEvaluation();
                break;
            case "ShiftReportTabBypassEdit":
                if (this.SelectedEvaluationRow() != null) {
                    this.EditReportEvaluation(this.SelectedEvaluationRow());
                }
                break;
            case "ShiftReportTabBypassDelete":
                if (this.SelectedEvaluationRow() != null) {
                    var yesnodialog = new BaoDialog(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgDelete"), "yesno");
                    yesnodialog.DialogResult.subscribe((res) => {
                        if (res === true) {
                            this.TabPage.IsLoading(true);
                            this.DeleteReportEvaluation(this.ShiftReport.ReportId(), this.SelectedEvaluationRow())
                                .then(() => {
                                    this.SelectedEvaluationRow(null);
                                    this.LoadData();
                                })
                                .always(() => { this.TabPage.IsLoading(false); });
                        }
                    });
                }
                break;
            case "ShiftReportTabBypassRefresh":
                this.SelectedEvaluationRow(null);
                this.LoadData();
                break;
        }
        ;
    };
    SelectRow = (item) => {
        this.SelectedEvaluationRow(item.evaluation);
        return true;
    };
    LoadMetadata() {
        this.TabPage.IsLoading(true);
        return this.getMetadataFromServer()
            .then(metadata => {
                this.EnableCompleteDate(metadata.EnableCompleteDate);
            });
    }
    LoadData() {
        this.TabPage.IsLoading(true);
        this.ToggleToolbarButtons();
        return this.getDataFromServer(this.ShiftReport.ReportId())
            .then(data => {
                this.EvaluationCollection(data.Evaluations);
                this.Columns(data.Columns);
                this.TotalRows(data.TotalRows);
                this.Fields(data.Fields);
                this.TabPage.IsLoading(false);
                this.TabPage.Title(this.OriginalTabTitle + " (" + data.TotalRows + ")");
            });
    }
    private getMetadataFromServer() {
        return Bao.post("BypassTab/GetMetadata");
    }
    private getDataFromServer(reportid: string) {
        return Bao.post("BypassTab/GetBypassCollection", JSON.stringify({
            reportId: reportid, pageIndex: this.PageIndex(),
            shiftbookTabId: this.TabPage.ObjectId(),
            pageSize: this.PageSize(),
            sorting: this.Sorting(),
            customFilter: this.ToHashObject(ko.unwrap(this.CustomFilter)),
            shiftStartTime: this.ShiftReport.ShiftStartTime(),
            shiftEndTime: this.ShiftReport.ShiftEndTime()
        }));
    }
    ToHashObject(customFilter) {
        var returnValue = [];
        for (var f in customFilter) {
            if (ko.unwrap(customFilter[f]).length > 0)
                returnValue.push({ Key: f, Value: ko.unwrap(customFilter[f]) });
        }
        return returnValue;
    }
    ;
    EditReportEvaluation = (item) => {
        baoRouter.setHash("checkware/evaluation/" + ko.unwrap(item.EvaluationId));
    };
    DeleteReportEvaluation = (reportId, evaluation) => {
        return Bao.post("BypassTab/DeleteEvaluation", JSON.stringify({
            reportId: reportId, evaluationId: evaluation.EvaluationId
        }));
    };
    CreateEvaluation = () => {
        return Bao.post("Dialog/CreateBypass", JSON.stringify({}), (result) => {
            var dialog = new BaoDialog(Bao.Session.ApplicationName);
            dialog.Template(result);
            dialog.ViewModel({ ReportId: this.ShiftReport.ReportId(), ShiftbookId: this.ShiftReport.ShiftbookId(), ShiftbookTabId: this.TabPage.ObjectId(), Dialog: dialog });
            dialog.Open(null);
        });
    };
}
export default ShiftReportBypass;